<div class="subtype-configuration-new">

  <div class="wrapper">
    <mee-subtype-point-configuration
      #pointConfiguration
      *ngIf="getIsParentObjectTypePoint()"
      [node]="node"
      [placeMarksFields]="placeMarksFields"
      [layers]="layers"
      [sourceType]="sourceType"
    ></mee-subtype-point-configuration>

    <mee-subtype-line-configuration
      #lineConfiguration
      *ngIf="getIsParentObjectTypeLine()"
      [node]="node"
      [placeMarksFields]="placeMarksFields"
      [layers]="layers"
      [sourceType]="sourceType"
    ></mee-subtype-line-configuration>


    <mee-area-subtype-configuration
      #areaConfiguration
      *ngIf="getIsParentObjectTypeArea()"
      [node]="node"
      [placeMarksFields]="placeMarksFields"
      [layers]="layers"
      [sourceType]="sourceType"
    ></mee-area-subtype-configuration>
  </div>

</div>
